<template>
  <OnexAlert
    v-if="message !== ''"
    :type="Notifications.error"
    dismissible="true"
    @click:close="message = ''"
  >
    <span>
      {{
        $t(
          'L_A_system_error_is_preventing_the_acceptance_for_the_updated_Terms_of_Use_Please_close'
        )
      }}
    </span>
  </OnexAlert>
  <v-card id="tou-card" class="text-center mt-4 space_to_go_under_bottom_button term_life_card_css">
    <v-card-text class="text-center pb-0">
      <v-row justify-content="center">
        <v-col cols="12" mb-2 class="font-weight-bold text-left">
          <h3 class="text-h1">{{ $t('L_our_terms_of_use_have_been_updated') }}</h3>
        </v-col>
      </v-row>
      <v-divider py-4 class="line_separator" />
      <v-row class="text-left py-4">
        <v-col cols="12" class="pb-2 text-h4 font-weight-regular">
          {{ $t('L_you_must_accept_the_updated_terms_to_continue_to_use_the_site') }}
        </v-col>
      </v-row>
      <v-row class="pb-0">
        <v-col cols="12" class="px-4" id="iframeContent">
          <iframe
            id="myiFrame"
            :class="$vuetify.display.xs ? 'iframe_mobile' : 'iframe_desktop'"
            frameBorder="0"
            :src="urlForTOU"
            title="Terms of Use"
            >Browser not compatible</iframe
          >
          <div class="gradientHover mr-4">&nbsp;</div>
        </v-col>
      </v-row>
      <v-row>
        <v-col><v-divider class="py-4 pt-0 no_border_color" /></v-col>
        <v-col cols="12" justify-content="center" class="px-4">
          <OnexButton color="primary" @click="acceptTOU">
            {{ $t('L_i_accept') }}
          </OnexButton>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { useGlobalStore } from '@/stores/global/global.store';
import { RouteNames } from '@/router/routeNames';
import { mapStores } from 'pinia';
import { Notifications, OnexButton, OnexAlert } from '@primerica/onex-ui-lib';
import type { IGlobalStoreTask } from '@/stores/global/globalStore.model.ts';

const componenOptions: ComponentOptions = {
  name: 'TermsOfUseModal',
  components: {
    OnexButton,
    OnexAlert,
  },
  data: () => ({
    message: '',
    type: 'error',
    Notifications,
    // editIsDisabled: true,
  }),
  computed: {
    ...mapStores(useGlobalStore),
    urlForTOU() {
      return this.globalStore.tasks?.filter(
        (task: IGlobalStoreTask) => task.name === 'TERMS_OF_USE'
      )[0]?.info?.agreementLink;
    },
  },
  mounted() {
    const iframe = document.getElementById('myiFrame') as HTMLIFrameElement | null;
    if (iframe?.style && iframe.contentWindow?.document.body) {
      iframe.style.height = `${iframe.contentWindow.document.body.scrollHeight}px`;
    }
    window.addEventListener('resize', () => this.onResize());
  },
  methods: {
    onResize() {
      const iframeContent = document.getElementById('iframeContent') as HTMLIFrameElement | null;
      if (iframeContent?.style && iframeContent.contentWindow?.document.body) {
        iframeContent.style.height = 'calc(100vh - 395px)';
      }

      const iframe = document.getElementById('myiFrame') as HTMLIFrameElement | null;
      if (iframe?.style && iframe.contentWindow?.document.body) {
        iframe.style.height = 'calc(100vh - 395px)';
      }
    },
    async acceptTOU() {
      this.message = '';
      const tempAgreementId = this.globalStore.tasks.filter(
        (task: IGlobalStoreTask) => task.name === 'TERMS_OF_USE'
      )[0]?.info.agreementId;
      let resp;
      try {
        resp = await this.globalStore.updateTermsOfUse(tempAgreementId);
      } catch (error) {
        try {
          this.$dynatrace.reportCustomError(
            'PC2_MOBILE_ERR',
            `[TermsOfUseModal - acceptTOU]: Error accepting Terms of Use: ${JSON.stringify(error)}`
          );
        } catch (_) {
          /*  */
        }
        this.message = this.$t(
          'L_A_system_error_is_preventing_the_acceptance_for_the_updated_Terms_of_Use_Please_close'
        );
        this.type = 'error';
      }
      if (resp) {
        const origTasks = this.globalStore.tasks;
        const modTasksWOTOU = origTasks.filter(
          (task: IGlobalStoreTask) => task.name !== 'TERMS_OF_USE'
        );
        this.globalStore.tasks = modTasksWOTOU;

        // navigate to next page
        const deeplinkroute = window.localStorage.getItem('deeplinkroute'); // ? this is a path, NOT name of a route
        let nextRoute = '';
        if (this.globalStore.hasPolicyAckTask) nextRoute = RouteNames.POLICY_ACKNOWLEDGEMENT;
        if (nextRoute.length === 0) {
          window.localStorage.removeItem('deeplinkroute'); // remove the deeplink route
          nextRoute = deeplinkroute ?? RouteNames.DASHBOARD; // there are no post login tasks
        }
        const nextRouteIsNamedRoute = Object.values<string>(RouteNames).includes(nextRoute);
        const _nextRouteOrPath = nextRouteIsNamedRoute ? { name: nextRoute } : { path: nextRoute };
        await this.$router.push(_nextRouteOrPath);
      } else {
        this.message = this.$t(
          'L_A_system_error_is_preventing_the_acceptance_for_the_updated_Terms_of_Use_Please_close'
        );
        this.type = 'error';
      }
    },
  },
};

export default defineComponent(componenOptions);
</script>

<style lang="scss" scoped>
.term_life_card_css {
  max-width: 960px;
  margin: auto;
}

.line_separator {
  border: 1px solid #bcbaba;
}

.text_align_left {
  text-align: left;
}

.fixed-top-alert {
  position: absolute;
  top: -4px;
  z-index: 1;
}

.iframe_mobile {
  width: 100%;
  border: 2px solid black;
  height: calc(100vh - 395px) !important;
}

.iframe_desktop {
  width: 100%;
  border: 2px solid black;
  height: calc(100vh - 395px);
}

.fixed_bottom_button_mobile {
  bottom: 10px;
  width: 280px !important;
  margin: auto !important;
}

.fixed_bottom_button_desktop {
  bottom: 10px;
  left: 10px;
  right: 10px;
  width: 280px !important;
  margin: auto !important;
}

.space_to_go_under_bottom_button {
  padding-bottom: 150px;
}

.no_border_color {
  border-color: transparent;
}

.zgradientHover {
  position: relative;
  bottom: 51px;
  left: 0;
  background: linear-gradient(rgba);
  width: 100%;
  height: 50px;
  background-image: -moz-linear-gradient(rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
  background-image: -o-linear-gradient(rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
  background-image: linear-gradient(rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
}

.dividerSpace {
  color: #8a8a8a;
}
</style>
